import { AppModule } from 'app/module';
import Template from './template.hbs';
import './styles.scss';

export class PillList extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            pillListItems: ['.m-pillList__item'],
        };
    }

    getPropsFromDom() {
        const items = [...this.dom.pillListItems].map((pillItem) => {
            const id = pillItem.getAttribute('data-id');
            return { value: pillItem.innerText, id };
        });

        return {
            items,
        };
    }

    domEvents() {
        for (let i = 0; i < this.dom.pillListItems.length; i += 1) {
            const el = this.dom.pillListItems[i].querySelector('.m-pillList__remove');
            el.addEventListener('click', (e) => {
                this.removeItem(e.currentTarget);
            });
        }
    }

    addItem(value, id) {
        this.props.items.push({ value, id });
        this.events.emit('itemsChanged', this.props.items);
        this.render();
    }

    removeItem(removeIcon) {
        const removableItemValue = removeIcon.parentNode.getAttribute('data-value');
        this.props.items = this.props.items.filter((item) => item.value !== removableItemValue);
        this.events.emit('itemsChanged', this.props.items);
        this.render();
    }

    getAllIds() {
        const ids = [];
        for (let i = 0; i < this.props.items.length; i += 1) {
            if (this.props.items[i].id !== null) {
                ids.push(this.props.items[i].id);
            }
        }
        return ids;
    }

    reduceListToArrays() {
        return this.props.items.reduce((acc, cur) => { acc.push(cur.value); return acc; }, []);
    }
}
